import axios from 'axios'
import {Notification} from "..";

export const EN = 42; // XC language code for language English
export const NL = 43; // XC language code for language Dutch

const BASE_URL = '/web/rest/language';

export function get(lang, label) {
    return axios.get(`${BASE_URL}/${lang}/${label}`).then(function (result) {
        return result.data;
    });
}


export function bulk(lang, labels) {
    if (lang !== EN && lang !== NL) {
        console.error('Unsupported language', lang);
        return;
    }

    if (!Array.isArray(labels)) {
        console.error('Labels parameter should be an array of language labels.', labels);
        return;
    }

    const missingLabels = [];
    const cachedLabels = {};
    labels.forEach(key => {
        const value = sessionStorage.getItem(key);
        if (value === null) {
            missingLabels.push(key);
        } else {
            cachedLabels[key] = value;
        }
    });

    if (missingLabels.length === 0) {
        return Promise.resolve(cachedLabels);
    }

    const encodedLabels = JSON.stringify(missingLabels);
    const url = `${BASE_URL}/${lang}/bulk`;

    if (url.length > 2000) {
        console.warn("Language label retrieve URL is longer than 2000 characters. Consider splitting up the bulk request into multiple requests.");
    }

    return axios.post(url, encodedLabels, {headers: {'Content-Type': 'application/json'}})
        .then(function (result) {
            const data = result.data;
            Object.keys(data).forEach((key) => {
                const value = result.data[key];
                sessionStorage.setItem(key, value);
                cachedLabels[key] = value;
            });
            return cachedLabels;
        }).catch(function (error) {
            Notification.notifyFailure(error, "Fout bij het ophalen van taallabels");
            labels.forEach(key => cachedLabels[key] = key);
            return Promise.resolve(cachedLabels);
        });
}
